import type { TimeEntry } from './types';
import './time-location.css';

const labels: Record<string, string> = { daily_login: 'Tagesanmeldung', clock_in: 'Arbeitsbeginn', clock_out: 'Arbeitsende', break_start: 'Pausenbeginn', break_end: 'Pausenende' };
const statuses: Record<string, string> = { not_captured: 'Standort nicht erfasst', recorded: 'Standort erfasst', not_required: 'Standort nicht erforderlich' };

export function TimeLocationEvidence({ evidence }: { evidence: TimeEntry['location_evidence'] }) {
  if (!evidence?.length) return null;
  const missing = evidence.filter(item => item.status === 'not_captured').length;
  const recorded = evidence.filter(item => item.status === 'recorded').length;
  const remaining = evidence.length - missing - recorded;
  return <details className={`time-location-summary ${missing ? 'not-captured' : ''}`}>
    <summary><strong>{missing ? 'Standort nicht erfasst' : recorded ? 'Standort erfasst' : 'Standortnachweise'}</strong><small>{[missing && `${missing} fehlend`, recorded && `${recorded} erfasst`, remaining && `${remaining} weitere`].filter(Boolean).join(' · ')} · Details</small></summary>
    <ul>{evidence.map((item, index) => <li key={index}>
      <strong>{labels[item.action] || item.action}</strong>
      <span>{statuses[item.status] || 'Standortstatus unbekannt'}{item.reason ? ` · ${item.reason}` : ''}</span>
      {item.occurred_at && Number.isFinite(Date.parse(item.occurred_at)) && <small>{new Date(item.occurred_at).toLocaleString('de-DE', { timeZone: 'Europe/Berlin', dateStyle: 'short', timeStyle: 'short' })}</small>}
    </li>)}</ul>
  </details>;
}
